let keyValue = {
  myStore: {
    priceType: [
      {
        id: 'JTJ',
        name: '阶梯价',
      },
      {
        id: 'YKJ',
        name: '一口价',
      },
      {
        id: 'DX',
        name: '电询',
      }
    ],
    validType: [
      {
        id: 'TODAY',
        name: '当日有效',
      },
      {
        id: 'FOREVER',
        name: '长期有效',
      }
    ],
    status: [
      {
        id: '0',
        name: '启用'
      },
      {
        id: '1',
        name: '禁用'
      }
    ],
    quotationStatus: [
      {
        id: '0',
        name: '生效'
      },
      {
        id: '1',
        name: '失效'
      }
    ],
    tradeStatus: [
      {
        id: '0',
        name: '有效'
      },
      {
        id: '1',
        name: '无效'
      },
      {
        id: '10',
        name: '售罄'
      }
    ],
    pickupType: [
      {
        id: 'PICKUP',
        name: '自提'
      },
      {
        id: 'DELIVERY',
        name: '送货上门'
      }
    ],
    actionType: [
      {
        id: 'QT',
        name: '是(报价+挂牌)'
      },
      {
        id: 'Q',
        name: '否(仅报价)'
      }
    ],
    reserveType: [
      {
        id: 'ORDER',
        name: '订单'
      },
      {
        id: 'RESERVE',
        name: '意向单'
      },
      {
        id: 'FAIL',
        name: '已取消'
      }
    ],
    orderStatus: [
      {
        id: '10',
        name: '摘牌完成，待挂牌方确认'
      },
      {
        id: '11',
        name: '摘牌完成，挂牌方拒绝交易'
      },
      {
        id: '12',
        name: '摘牌完成，后续交易中'
      },
      {
        id: '13',
        name: '摘牌完成，后续交易失败'
      },
      {
        id: '14',
        name: '摘牌完成，后续交易成功'
      },
      {
        id: '1',
        name: '摘牌方主动撤销'
      }
    ],
    clearingForm: [
      {
        id: 'ONLINE',
        name: '线上结算'
      },
      {
        id: 'OFFLINE',
        name: '线下结算'
      }
    ],
    orderTag: [
      {
        id: 'S',
        name: '销售'
      },
      {
        id: 'P',
        name: '采购'
      }
    ]

  },
}
export default keyValue
